// extracted by mini-css-extract-plugin
module.exports = {"root":"_989999","text":"_60c8e4","header":"_01101f","nameLogoContainer":"_e73565","logo":"_984c22"};